// extracted by mini-css-extract-plugin
module.exports = {"stepsContainer":"styles_stepsContainer__DoGzV","stepsItem":"styles_stepsItem__x+tKH"};